export const TOOLTIP_POSITIONS = {
  TOP: 'top',
  BOTTOM: 'bottom',
};
